import {
  bindStreamLainDisclosure,
  streamLainDisclosureStyles,
} from '@blocksuite/affine-shared/utils';
import { ArrowRightSmallIcon } from '@blocksuite/icons/rc';
import clsx from 'clsx';
import {
  type ReactElement,
  type ReactNode,
  useLayoutEffect,
  useRef,
} from 'react';

export function StreamLainDisclosureStyles(): ReactElement {
  return (
    <style data-streamlain-disclosure-styles>
      {streamLainDisclosureStyles}
    </style>
  );
}

export function StreamLainDisclosure({
  children,
  className,
  summary,
}: {
  children: ReactNode;
  className?: string;
  summary: ReactNode;
}): ReactElement {
  const detailsRef = useRef<HTMLDetailsElement>(null);
  useLayoutEffect(() => {
    const details = detailsRef.current;
    if (!details) return;
    return bindStreamLainDisclosure(details);
  }, []);

  return (
    <details
      ref={detailsRef}
      className={clsx('streamlain-inline-disclosure', className)}
    >
      <summary className="streamlain-inline-disclosure-trigger">
        <span>{summary}</span>
        <span
          className="streamlain-inline-disclosure-chevron"
          aria-hidden="true"
        >
          <ArrowRightSmallIcon width={16} height={16} />
        </span>
      </summary>
      <div className="streamlain-inline-disclosure-body">
        <div className="streamlain-inline-disclosure-body-inner">
          {children}
        </div>
      </div>
    </details>
  );
}
